import React from 'react';
import { Link } from 'react-router-dom'; // Import the Link component from React Router
import CountUp from 'react-countup';
// Import images
import footerLogo from '../../../assets/images/resources/ramana-machine-white-logo3.png'; // Replace with your actual path
import footerBgShape from '../../../assets/images/shapes/site-footer-two-bg-shape.png'; // Replace with your actual path


const locationstyle = {
    color: 'white',
    padding: '3px',
    margin: '3px',


}
const FooterTwo = () => {
    return (
        <footer className="site-footer-two">
            <div
                className="site-footer-two__bg-shape float-bob-y"
                style={{ backgroundImage: `url(${footerBgShape})` }}
            ></div>
            <div className="site-footer-two__top">
                <div className="container">
                    <div className="site-footer-two__top-inner">
                        <div className="row">
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                                <div className="footer-widget-two__column footer-widget-two__about">
                                    <div className="footer-widget-two__logo">
                                        <Link to="/">
                                            <img src={footerLogo} alt="Footer Logo" />
                                        </Link>
                                    </div>
                                    <p className="footer-widget-two__about-text">
                                        As a proud subsidiary of Ramana Machines, Ramana Steels stands at the forefront of high-grade steel solutions and advanced scrap processing machinery. ...<Link to={"/about"}>Read More</Link>
                                    </p>
                                    <div className="footer-widget-two__social">
                                        <Link to="https://www.facebook.com/profile.php?id=61573443062800"><span className="icon-facebook-f"></span></Link>
                                        <Link to="https://x.com/design79356"><span className="icon-Vector"></span></Link>
                                        <Link to="https://www.instagram.com/ramanasteels/"><span className="icon-instagram"></span></Link>
                                        <Link to="https://in.pinterest.com/Ramanasteels/"><span className="icon-pinterest"></span></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                                <div className="footer-widget-two__column footer-widget-two__contact">
                                    <div className="footer-widget-two__title-box">
                                        <h3 className="footer-widget-two__title">Head Office</h3>
                                    </div>
                                    <div className="footer-widget-two__contact-inner">
                                        <ul className="footer-widget-two__contact-list list-unstyled">
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-envelope"></span>
                                                </div>
                                                <div className="text">
                                                    <p><a href="mailto:rwassist.rw@gmail.com">rwassist.rw@gmail.com</a></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-location"></span>
                                                </div>
                                                <div className="text">
                                                    <p>  Ramana Machines, Krishna <br /> Colony,  Street Number 10,<br /> Gehlewal,  LDH, PB 141007</p>
                                                    {/* <p>3891 Ranchview Dr.<br /> Richardson</p> */}
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-call"></span>
                                                </div>
                                                <div className="text">
                                                    <p><a href="tel:9815902561">+91-9815902561 <br /> Parmesh Wassist (Roby)</a>, {/* <a href="tel:9815902561">9815902561</a> */}</p>
                                                </div>
                                            </li>




                                        </ul>

                                    </div>

                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                                <div className="footer-widget-two__column footer-widget-two__contact">
                                    <div className="footer-widget-two__title-box">
                                        <h3 className="footer-widget-two__title">Our Products</h3>
                                    </div>
                                    <div className="footer-widget-two__contact-inner">
                                        <ul className="footer-widget-two__contact-list list-unstyled">
                                            <li>
                                                <div className="text bi bi-arrow-right ">
                                                    <p >              <a href="/horizontal-automatic-container-shear">Horizontal Automatic Container Shearing Machine </a></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="text bi bi-arrow-right ">
                                                    <p >              <a href="/vertical-scrap-shear">Vertical Heavy Duty Scrap Shearing Machine </a></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="text bi bi-arrow-right ">
                                                    <p >              <a href="/hydraulic-scrap-baler">Hydraulic Scrap Baler </a></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="text bi bi-arrow-right ">
                                                    <p >              <a href="/double-shaft-shredder">Double Shaft Scrap Shredder </a></p>
                                                </div>
                                            </li>
                                            {/* <li>
                                                <div className="text bi bi-arrow-right ">
                                                    <p >              <a href="/movable-excavator">Movable Excavator </a></p>
                                                </div>
                                            </li> */}
                                            <li>
                                                <div className="text bi bi-arrow-right ">
                                                    <p >              <a href="/scrap-magnet">Scrap Magnet </a></p>
                                                </div>
                                            </li>

                                            {/* <li>
                                                <div className="text bi bi-arrow-right ">
                                                    <p >              <a href="/fixed-boom-excavator">Fixed Boom Excavator </a></p>
                                                </div>
                                            </li> */}
                                            <li>
                                                <div className="text bi bi-arrow-right ">
                                                    <p >              <a href="/grabber">Scrap Grabber </a></p>
                                                </div>
                                            </li>

                                            {/* <li>
                                                <div className="icon">
                                                    <span className="icon-location"></span>
                                                </div>
                                                <div className="text">
                                                    <p>  First Floor, Near Bansal Auto,<br /> G.T. Road, Sirhind Side, Opp.<br /> Chanan Ram Diwan, Chand <br />Petrol Pump, Mandi<br /> Gobindgarh Tehsil  <br />Amloh, Distt.,<br /> Fatehgarh Sahib </p>

                                                </div>
                                            </li> */}
                                            {/* <li>
                                                <div className="icon">
                                                    <span className="icon-call"></span>
                                                </div>
                                                <div className="text">
                                                    <p><a href="tel:9815902561">+91-9815902561 - Parmesh Wassist (Roby)</a></p>
                                                </div>
                                            </li> */}




                                        </ul>

                                    </div>

                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                                <div className="footer-widget-two__column footer-widget-two__newsletter">
                                    <p className="footer-widget-two__newsletter-title"><span>Subscribe</span> to Our<br /> Newsletter</p>
                                    <form className="footer-widget-two__newsletter-form mc-form" data-url="MC_FORM_URL" noValidate>
                                        <div className="footer-widget-two__newsletter-form-input-box">
                                            <input type="email" placeholder="Your e-mail" name="EMAIL" />
                                            <button type="submit" className="footer-widget-two__newsletter-btn"><span className="icon-paper-plane"></span></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" d-flex locatons" style={{ background: "#2F8CD6", justifyContent: 'space-between', padding: '0 40px', margin: '50px 0 50px 0' }}> <h3 style={locationstyle}>Delhi NCR</h3>
                        <h3 className='border-element' style={locationstyle}>Panipat</h3> <h3 className='border-element' style={locationstyle}>Mumbai</h3> <h3 className='border-element' style={locationstyle}>Kolkata</h3>
                        <h3 className='border-element' style={locationstyle}>Surat</h3> <h3 className='border-element' style={locationstyle}>Bahadurgarh</h3></div>
                </div>

            </div>

            <div className="site-footer-two__bottom">
                <div className="container">
                    <div className="site-footer-two__bottom-inner">
                        <p className="site-footer-two__bottom-text">© Ramana Steels 2025  </p>
                        {/* <ul className="list-unstyled site-footer-two__bottom-menu">
                            <li><Link to="/about">Terms & Conditions</Link></li>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                        </ul> */}
                    </div>
                </div>
            </div>

        </footer>
    );
};

export default FooterTwo;
